import type { SVGProps } from "react";
const SenecPictogramCommuneStadtwerke = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M25 9C25.5523 9 26 9.44772 26 10V23H28V10C28 9.44772 28.4477 9 29 9C29.5523 9 30 9.44772 30 10V23H46V39H33C32.4477 39 32 38.5523 32 38C32 37.4477 32.4477 37 33 37H44V25H26V37H28C28.5523 37 29 37.4477 29 38C29 38.5523 28.5523 39 28 39H24V10C24 9.44772 24.4477 9 25 9Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 14.3423L16 18.4256V23.542L19 25.4511V39H6V33H2V18.4256L9 14.3423ZM6 31V25.4511L12.5 21.3147L14 22.2692V19.5744L9 16.6577L4 19.5744V31H6ZM8 26.5489V37H17V26.5489L12.5 23.6853L8 26.5489Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramCommuneStadtwerke;
